<template>
  <div>
    <LayoutDefaultHeader />
    <main class="layout-main">
      <slot />
    </main>
    <LayoutDefaultFooter />
  </div>
</template>

<style lang="scss" scoped>
.layout-main {
  max-width: var(--app-layout-default-max-width);
  padding: 0 var(--app-layout-default-page-padding);
  margin: 0 auto;
  min-height: 30vh;
}
</style>
